import { useCallback } from 'react'

import { useWorkerProfileQuery } from '@front/api/bff-worker/useWorkerProfileQuery'
import { type SegmentAdditionalProperties, track } from '@front/logic/segment'
import { getAnalytics } from '@front/logic/segment/global.analytics'
import type { WorkerProfile } from '@front/type/worker/worker'

interface TrackEventProps {
  event: string
  additionalProperties?: SegmentAdditionalProperties
}

interface TrackingProps {
  isPublicPage?: boolean
}

interface TrackingHook {
  track: (props: TrackEventProps) => void
  user?: WorkerProfile
}

export const useWorkerTracking = ({
  isPublicPage = false,
}: TrackingProps = {}): TrackingHook => {
  const { data: worker } = useWorkerProfileQuery(!isPublicPage)

  const trackEvent = useCallback(
    ({ event, additionalProperties }: TrackEventProps) => {
      track(
        event,
        {
          ...additionalProperties,
        },
        getAnalytics(),
      )
    },
    [],
  )

  return { track: trackEvent, user: worker as WorkerProfile }
}
